import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import styles from "./StudentsList.module.css";
import { ImageUrlPrefix, R_PER_PAGE } from "../../../../../labels";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { Modal } from "react-bootstrap";
import { AxiosInstance } from "../../../../../axios";
import { styled } from "@mui/material/styles";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import moment from "moment";
import toast from "react-hot-toast";
import Loader from "../../../Loader";
import Swal from "sweetalert2";
import CustomDownloadButton from "../../../../ReusuableComponent/CustomDownloadButton/CustomDownloadButton";
// import jsPDF from "jspdf";
import "jspdf-autotable";
// import { ExportTableToPdf } from "../../../../ReusuableComponent/ExportTableToPdf";

function StudentsList() {
  let page = R_PER_PAGE;
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(page);
  const [sortOrder, setSortOrder] = useState("");
  const [statusT, setStatusT] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const userJSON = sessionStorage.getItem("userDetails");
  const [csvData, setCsvData] = useState([]);
  let staff_id = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.id) {
      staff_id = user.id;
    }
  } else {
    console.log("User Id cannot avaliable in session storage");
  }
  const [show, setShow] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate(); // Initialize the navigate function
  const [updateChipData, setUpdateChipData] = useState([]);
  const [isOpen, setIsOpen] = useState({ status: false });
  const [status, setStatus] = useState([]);
  const [dataItem, setDataItem] = useState([]);
  // Function to handle button click
  const handleButtonClick = (
    userid,
    eventid,
    attempt_no,
    answerPath,
    batch_id
  ) => {
    navigate("/ViewStudent", {
      state: {
        userIdView: userid,
        eventIDView: eventid,
        ANSWERSHEETPATH: answerPath,
        BATCHID: batch_id,
      },
    });
  };
  //function to download answer sheet
  const handleFileDownload = (pdfdata) => {
    if (pdfdata) {
      window.open(`${ImageUrlPrefix}/${pdfdata}`, "_blank");
    } else {
      toast.error("Data Not Found", {
        autoClose: 2000, // Duration in milliseconds
      });
    }
  };
  // chipdata listitem
  const ListItem = styled("li")(({ theme }) => ({
    margin: theme.spacing(0.5),
  }));

  //chips overall clear button
  const handleAllClear = () => {
    setStatusT([]);
    setStatus([]);
    setUpdateChipData([]);
    setFilteredData([]);
  };
  //chips delete button
  const handleDelete = (chipToDelete, index) => () => {
    updateStateData();
    if (chipToDelete.type === "status") {
      setStatusT(statusT.filter((item) => item.id !== chipToDelete.id));
      setStatus(status.filter((item) => item.id !== chipToDelete.id));
      filterStatus = statusT.filter((item) => item.id !== chipToDelete.id);
    }
    loadChipdata();
  };

  // total table data  with pages
  const handlePrev = (newPage) => {
    if (newPage >= 1) {
      setCurrentPage(newPage);
    }
  };

  // handlenext pagination
  const handleNext = (newPage) => {
    if (newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  //  pagination per page count
  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // loadlistdata calling whenever updatechipdata update

  useEffect(() => {
    loadListdata();
  }, [updateChipData]);

  const [CountData, setCountData] = useState({
    unassign_count: "",
    assign_count: "",
  });

  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const [filteredData, setFilteredData] = useState([]);
  const [allPublished, setAllPublished] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false); // Track if filters are applied
  const filterRef = useRef(null);
  const currentDatas = filteredData.slice(start, end);
  const [error, setError] = useState([]);
  // mobile tooltip
  const totalPages = Math.ceil(filteredData?.length / rowsPerPage);
  const totalRecords = filteredData?.length || 0;
  let pressTimer;
  document.querySelectorAll(".tooltip-container").forEach((el) => {
    el.addEventListener("touchstart", function () {
      pressTimer = setTimeout(() => {
        this.classList.add("active");
      }, 500); // Long press duration
    });

    el.addEventListener("touchend", function () {
      clearTimeout(pressTimer);
      this.classList.remove("active");
    });
  });

  // applyfilter function

  const handleApplyFilter = (name) => {
    updateStateData();
    if (name === "status") {
      loadChipdata();
      const filtered =
        status.length > 0
          ? filteredData.filter((course) =>
              status.some((s) => s.id === String(course.eva_status))
            )
          : filteredData;
      setFilteredData(filtered);
      setIsOpen({ ...isOpen, status: false });
      setIsFiltered(status.length > 0); // Set isFiltered based on selected status
      setStatusT(status);
    }
  };

  // filter checkbox checked

  const handleCheckboxChange = (event) => {
    const { name, value, checked } = event.target;
    setStatus((prevStatus) => {
      if (checked) {
        return [...prevStatus, { id: value, name: name, type: "status" }];
      } else {
        return prevStatus.filter((item) => item.id !== value);
      }
    });
  };

  // filter box open and close functionality

  const handleFilter = (e, boxName) => {
    if (boxName === "evaluationStatus") {
      setIsOpen((prevState) => {
        const newState = { ...prevState, status: !prevState.status };
        // If opening the dropdown, set isFiltered to true
        if (!prevState.status) {
          setIsFiltered(true);
          setStatus(statusT);
        }
        return newState;
      });
    } else {
      setIsFiltered(false); // Reset filter state for other boxes
    }
  };

  // clear in filter box

  const handleClear = (name) => {
    if (name === "status") {
      setStatus([]);
      setIsOpen({ ...isOpen, status: false });
      setIsFiltered(false); // Reset filter state
    }
  };

  // close the popu when mouse click outside

  const handleClickOutside = (event) => {
    const isChipData = event.target.closest(".paperil_global");
    if (
      filterRef.current &&
      !filterRef.current.contains(event.target) &&
      !isChipData
    ) {
      // Only reset isFiltered if the filter dropdown is closed
      if (!isOpen.status && statusT.length === 0) {
        setIsFiltered(false);
      }
      setIsOpen((prevState) => ({ ...prevState, status: false }));
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  let filterStatus = [];
  useEffect(() => {
    filterStatus = status;
  }, [status]);
  // update filter state
  function updateStateData() {
    filterStatus = status;
  }
  // load table data based on filter

  function loadListdata() {
    let typeStatus = [];
    statusT.map((obj) => {
      typeStatus.push(obj.id);
    });
    let statusFilter = {
      staff_id: staff_id,
      event_id: "", // event give from admin side list faculty side give as empty
      add_more_status: 0, // faculty side default as 0
      status:
        typeStatus.length > 0 && typeStatus.length < 2
          ? parseInt(typeStatus[0])
          : "",
    };
    setIsLoading(true);
    AxiosInstance.post("api/test/descriptive/stud_list", statusFilter)
      .then((res) => {
        if (res.data.status === true) {
          setIsLoading(false);
          const fiata = res.data.data.stud_data;
          const serialNumberAddedData = fiata.map((data, index) => ({
            ...data,
            serialNumber: index + 1,
          }));
          const allPublished = serialNumberAddedData.every(
            (item) => item.publish_results == 1
          );
          setAllPublished(allPublished);
          const csvFormattedData = serialNumberAddedData.map((item) => ({
            serialNumber: item.serialNumber,
            admissionID: item.admissionID,
            assignedDate: moment(item.assignedDate).format("DD/MM/YYYY"),
            dueDate: item.dueDate
              ? moment(item.dueDate).format("DD/MM/YYYY")
              : "_",
            evaluationStatus:
              item.evaluationStatus === 0
                ? "Not Yet Evaluated"
                : item.evaluationStatus === 1
                ? "Evaluated"
                : "Result Published",
          }));
          // Set CSV data
          setCsvData(csvFormattedData);
          setFilteredData(serialNumberAddedData);
          const assign_status_data = res.data.data.assign_staus
            ? res.data.data.assign_staus
            : [];
          setDataItem(assign_status_data);
        } else if (res.data.status === false) {
          setIsLoading(false);
          setFilteredData([]);
          setDataItem([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setFilteredData([]);
        setDataItem([]);
        return error;
      });
  }
  // update chipdata functionality
  function loadChipdata() {
    let tempArr = [];
    filterStatus.map((obj) => {
      tempArr.push(obj);
    });
    setUpdateChipData(tempArr);
  }
  // sorting functionality
  const handleSort = (event, sortKey) => {
    event.preventDefault();

    let order =
      sortOrder === "asc" ? "desc" : sortOrder === "desc" ? "asc" : "desc";
    setSortOrder(order);
    let sortedList = filteredData.sort((a, b) => {
      if (a[sortKey] < b[sortKey]) {
        return order === "asc" ? -1 : 1;
      }
      if (a[sortKey] > b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      if (a[sortKey] == b[sortKey]) {
        return order === "asc" ? 1 : -1;
      }
      return 0;
    });
    setFilteredData(sortedList);
  };

  const handleClose = () => {
    setShow(false);
    setError({
      ...error,
      assign_count: "",
      unassign_count: "",
    });
    setCountData({
      assign_count: "",
      unassign_count: "",
    });
  };
  const handleShow = () => setShow(true);
  const handleOpen = () => setOpen(true);
  const handleModelClose = () => {
    setOpen(false);
    setError({
      ...error,
      assign_count: "",
      unassign_count: "",
    });
    setCountData({
      assign_count: "",
      unassign_count: "",
    });
  };

  // assign and unassign handlechange
  const handlechangeCount = (e) => {
    const { name, value } = e.target;

    // Allow only digits and max 2 characters
    if (/^\d{0,2}$/.test(value)) {
      setCountData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));

      setError((prevError) => ({
        ...prevError,
        [name]: "",
      }));
    }
  };

  // validate assign and unassign count
  const validateCount = (data, typeEv) => {
    const errors = {};
    if (data.assign_count === "" && typeEv === 1) {
      errors.assign_count = "Please enter count";
    } else if (data.unassign_count === "" && typeEv === 0) {
      errors.unassign_count = "Please enter count";
    } else if (
      data.unassign_count &&
      parseInt(data.unassign_count) > filteredData.length &&
      typeEv === 0
    ) {
      errors.unassign_count =
        "You can unassign students only upto the 'Not Yet Evaluated' count";
    } else if (
      data.unassign_count &&
      parseInt(data.unassign_count) >
        filteredData.filter((ui) => ui.evaluated_status === 0).length &&
      typeEv === 0
    ) {
      errors.unassign_count =
        "You can unassign students only upto the 'Not Yet Evaluated' count";
    }
    return errors;
  };
  //  sent request  assign and unassign
  const handleSendRequest = (type) => {
    const errors = validateCount(CountData, type);
    if (Object.keys(errors).length === 0) {
      let statusFilter = {
        staff_id: staff_id,
        count:
          type === 0
            ? parseInt(CountData.unassign_count)
            : parseInt(CountData.assign_count),
      };
      AxiosInstance.post(
        `${
          type === 0
            ? "api/test/descriptive/unassign_more_count"
            : "api/test/descriptive/assign_more_count"
        }`,
        statusFilter
      )
        .then((res) => {
          if (res.data.status === true) {
            Swal.fire({
              title: "Success",
              text: res.data.message,
              icon: "success",
              confirmButtonText: "Ok",
            });
            const bg = type === 0 ? "unassign_count" : "assign_count";
            setCountData((prevFormData) => ({
              ...prevFormData,
              [bg]: "",
            }));
            type === 0 ? handleClose() : handleModelClose();
            loadListdata();
          } else if (res.data.status === false) {
            Swal.fire({
              title: "Success",
              text: res.data.message,
              icon: "success",
              confirmButtonText: "Ok",
            });
            type === 0 ? handleClose() : handleModelClose();
          }
        })
        .catch((error) => {
          return error;
        });
    } else {
      setError(errors);
    }
  };

  const generatePDF = () => {
    const headers = [
      "S.No",
      "Admission ID",
      "Assigned Date",
      "Due Date",
      "Evaluation Status",
    ];

    const rows = csvData.map((item, index) => [
      index + 1,
      item.admissionID ?? "-",
      item.assignedDate ?? "-",
      item.dueDate ?? "-",
      item.evaluationStatus === 0
        ? "Not Yet Evaluated"
        : item.evaluationStatus === 1
        ? "Evaluated"
        : "Result Published",
    ]);
    if (rows.length <= 500) {
      navigate("/preview", {
        state: {
          title: "Students List Data",
          headers,
          rows,
          filename: "StudentsList.pdf",
          autoPrint: true,
        },
      });
    } else {
      toast.error(
        "The PDF cannot be generated because the data exceeds 500 records. Please apply filters and try again."
      );
    }
  };

  const csvHeaders = [
    { label: "S.No", key: "serialNumber" },
    { label: "Admission ID", key: "admissionID" },
    { label: "Assigned Date", key: "assignedDate" },
    { label: "Due Date", key: "dueDate" },
    { label: "Evaluation Status", key: "evaluationStatus" },
  ];

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <>
      <div
        className={`${styles.studentMain} container-fluid global_container BathHeader`}
      >
        <div className="row">
          <div className=" col-md-5 col-12 ">
            <h6 className="TitleHeader ">Students List</h6>
          </div>
          <div className="col-md-7 col-12 ListBtn">
            <ul class="List-Button">
              <li class="ListBtnItems">
                <CustomDownloadButton
                  csvListData={csvData?.length > 0 ? csvData : ""}
                  headers={csvHeaders}
                  iconName=" file_download "
                  filename={"StudentsList.csv"}
                  csvName="  Download as CSV"
                />
              </li>
              <li class="ListBtnItems primaryButton" onClick={generatePDF}>
                <span className="material-icons me-1 align-middle text-white">
                  file_download
                </span>
                Download as PDF
              </li>
              <li class="ListBtnItems">
                <Link
                  onClick={
                    filteredData.length > 0 && // Ensure filteredData is not empty
                    filteredData.some((ui) => ui.evaluated_status == 0) && // Check for at least one `evaluated_status == 0`
                    (dataItem.length === 0 ||
                      (dataItem.length > 0 && dataItem[0].assign_count > 0)) // Validate dataItem conditions
                      ? handleShow
                      : () => {}
                  }
                  to={"javascript:void(0)"}
                  className={`primaryButton ${
                    filteredData.length > 0 && // Ensure filteredData is not empty
                    filteredData.some((ui) => ui.evaluated_status == 0) && // Check for at least one `evaluated_status == 0`
                    (dataItem.length === 0 ||
                      (dataItem.length > 0 && dataItem[0].assign_count > 0)) // Validate dataItem conditions
                      ? "" // Enable button
                      : "disabledbtn" // Disable button
                  }`}
                  style={{
                    pointerEvents:
                      filteredData.length > 0 && // Ensure filteredData is not empty
                      filteredData.some((ui) => ui.evaluated_status == 0) && // Check for at least one `evaluated_status == 0`
                      (dataItem.length === 0 ||
                        (dataItem.length > 0 && dataItem[0].assign_count > 0)) // Validate dataItem conditions
                        ? "auto" // Enable interactions
                        : "none disabledbtn", // Disable interactions
                  }}
                >
                  Unassign Students
                </Link>
              </li>
              <li class="ListBtnItems">
                <Link
                  onClick={
                    filteredData.length === 0 ||
                    (dataItem.length > 0 && dataItem[0].unassign_count > 0) ||
                    allPublished
                      ? () => {}
                      : handleOpen
                  }
                  to={"javascript:void(0)"}
                  className={`primaryButton ${
                    filteredData.length === 0 ||
                    (dataItem.length > 0 && dataItem[0].unassign_count > 0) ||
                    allPublished
                      ? "disabledbtn"
                      : ""
                  }`}
                  style={{
                    pointerEvents:
                      filteredData.length === 0 ||
                      (dataItem.length > 0 && dataItem[0].unassign_count > 0) ||
                      allPublished
                        ? "none disabledbtn" // Disable interactions
                        : "auto", // Enable interactions
                  }}
                >
                  Assign More Students
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* chipdata related code  */}
        {updateChipData.length > 0 ? (
          <div className="row mt-3">
            <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
              <Paper
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  flexWrap: "wrap",
                  listStyle: "none",
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {updateChipData.map((data, index) => {
                  let icon;
                  let key = "" + data.name;
                  return (
                    <ListItem key={data}>
                      <Chip
                        icon={icon}
                        label={key}
                        onDelete={handleDelete(data, index)}
                      />
                    </ListItem>
                  );
                })}
                <ListItem className="clearAll_list">
                  <a
                    className={"clearAll_listItem"}
                    href="#"
                    onClick={handleAllClear}
                  >
                    Clear All Filters
                  </a>
                </ListItem>
              </Paper>
            </div>
          </div>
        ) : (
          <div></div>
        )}
        {/* StudentList Table */}
        <div className="row mt-3 mx-0">
          <div className="col-md-12 table-responsive tableMinHeight px-0">
            <table className="table" id="tableListHeader">
              <thead>
                <tr>
                  <th id="th">
                    <span className="textHead_th">S.No.</span>
                    <span
                      className="material-icons align-middle"
                      onClick={(e) => handleSort(e, "serialNumber")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span className="textHead_th">Admission ID</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "admissionID")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span className="textHead_th">Assigned Date</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "assignedDate")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th">
                    <span className="textHead_th">Due Date</span>
                    <span
                      className="material-icons textHead_th align-middle"
                      onClick={(e) => handleSort(e, "dueDate")}
                    >
                      import_export
                    </span>
                  </th>
                  <th id="th" ref={filterRef}>
                    <span className="textHead_th">Evaluation Status</span>
                    <span
                      className="textHead_th material-icons align-middle"
                      onClick={(e) => handleSort(e, "evaluationStatus")}
                    >
                      import_export
                    </span>
                    <span
                      className={`textHead_th align-middle material-icons ${
                        statusT.length > 0 ? styles.active_icons : ""
                      } ${isOpen.status ? styles.active_icons : ""}`} // Change here
                      onClick={(e) => handleFilter(e, "evaluationStatus")}
                    >
                      filter_list
                    </span>
                    {isOpen.status && (
                      <div className="filterBoxs_testlist">
                        <div className="col-md-12 form-check filterStatus_list">
                          <ul className="ulFilterListData">
                            <li className="filterListData">
                              <input
                                type="checkbox"
                                className="ListCheckbox"
                                name="Not Yet Evaluated"
                                value="0"
                                id="Not Yet Evaluated"
                                checked={status.some(
                                  (element) => element.id === "0"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <label
                                className="form-check-label filterChipText bg-pink"
                                htmlFor="Not Yet Evaluated"
                              >
                                Not Yet Evaluated
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                type="checkbox"
                                className="ListCheckbox"
                                name="Evaluated"
                                value="1"
                                id="Evaluated"
                                checked={status.some(
                                  (element) => element.id === "1"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <label
                                className="bg-green filterChipText form-check-label"
                                htmlFor="Evaluated"
                              >
                                Evaluated
                              </label>
                            </li>
                            <li className="filterListData">
                              <input
                                type="checkbox"
                                className="ListCheckbox"
                                name="Result Published"
                                value="2"
                                id="Result Published"
                                checked={status.some(
                                  (element) => element.id === "2"
                                )}
                                onChange={handleCheckboxChange}
                              />
                              <label
                                className="bg-grey filterChipText form-check-label"
                                htmlFor="Result Published"
                              >
                                Result Published
                              </label>
                            </li>
                          </ul>
                        </div>
                        <div className="borderWidth row">
                          <ul className="List-Button">
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleClear("status")}
                                className="secondaryButton ms-2"
                              >
                                Clear
                              </Link>
                            </li>
                            <li className="ListBtnItems">
                              <Link
                                onClick={() => handleApplyFilter("status")}
                                className="primaryButton"
                              >
                                Apply Filter
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </th>

                  <th id="th">
                    {" "}
                    <span className="textHead_th">Action</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {currentDatas && currentDatas.length === 0 ? (
                  <tr>
                    <td
                      colSpan="15"
                      style={{
                        textAlign: "center",
                        borderBottom: "1px solid #dee2e6",
                      }}
                    >
                      No records to display
                    </td>
                  </tr>
                ) : (
                  currentDatas.map((course, index) => (
                    <tr className={styles.rowHover} key={index}>
                      <td id="td">
                        {course.serialNumber ? course.serialNumber : "_"}
                      </td>
                      <td id="td">
                        {course.admissionID ? course.admissionID : "_"}
                      </td>
                      <td id="td">
                        {course.assignedDate
                          ? moment(course.assignedDate).format("DD/MM/YYYY")
                          : "_"}
                      </td>
                      <td id="td">
                        {course.dueDate
                          ? moment(course.dueDate).format("DD/MM/YYYY")
                          : "_"}
                      </td>
                      {course.evaluated_status === 0 && (
                        <td id="td">
                          <span className="bg-pink filterChipText">
                            Not Yet Evaluated
                          </span>
                        </td>
                      )}
                      {course.evaluated_status === 1 && (
                        <td id="td">
                          <span className="bg-green filterChipText">
                            Evaluated
                          </span>
                        </td>
                      )}
                      {course.evaluated_status === 2 && (
                        <td id="td">
                          <span className="bg-grey filterChipText">
                            Result Published
                          </span>
                        </td>
                      )}
                      <td id="td" className="d-flex">
                        <button
                          onClick={() =>
                            handleButtonClick(
                              course.user_id,
                              course.event_id,
                              course.attempt_no,
                              course.answer_sheet_path,
                              course.batch_id
                            )
                          }
                          disabled={
                            course.evaluated_status === 2 ? true : false
                          }
                          className={`view_icon_button d-flex`}
                        >
                          <span
                            className={`${
                              course.evaluated_status === 2
                                ? "visibleicon material-icons disabled_btn"
                                : "visibleicon material-icons"
                            } `}
                          >
                            visibility
                          </span>
                        </button>
                        <button
                          disabled={
                            course.evaluated_status === 2 ? true : false
                          }
                          onClick={() =>
                            handleFileDownload(course.answer_sheet_path)
                          }
                          className={`view_icon_button d-flex`}
                        >
                          <span
                            className={`${
                              course.evaluated_status === 2
                                ? " material-icons disabled_btn"
                                : " material-icons"
                            } `}
                          >
                            file_download
                          </span>
                        </button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          <div className="row mt-2">
            <Pagination
              rowsPerPage={rowsPerPage}
              handlePageCount={handlePageCount}
              startPage={
                totalRecords > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0
              }
              endPage={
                totalRecords > 0
                  ? Math.min(currentPage * rowsPerPage, totalRecords)
                  : 0
              }
              totalRecords={totalRecords}
              handlePrev={() =>
                totalRecords > 0 &&
                setCurrentPage((prev) => Math.max(prev - 1, 1))
              }
              currentPrevPage={currentPage === 1 || totalRecords === 0}
              prevButton={`${styles.prev_buttonViewEvaluator} ${styles.materialIconsRightAndLeft} me-2`}
              handleNext={() =>
                totalRecords > 0 &&
                setCurrentPage((prev) =>
                  Math.min(prev + 1, Math.ceil(totalRecords / rowsPerPage))
                )
              }
              currentNextPage={
                currentPage === Math.ceil(totalRecords / rowsPerPage) ||
                totalRecords === 0
              }
            />
          </div>
        </div>

        {/* Unassign Requests */}
        {dataItem.length > 0 &&
          (dataItem[0].assign_count > 0 || dataItem[0].unassign_count > 0) && (
            <div className="row m-0">
              <fieldset className="mt-3">
                <legend className="w-auto">
                  {dataItem[0].assign_count > 0
                    ? "Assign Requests"
                    : "Unassign Requests"}
                </legend>
                <div className="row mb-3">
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">
                        Number of students you want to{" "}
                        {dataItem[0].assign_count > 0 ? "assign" : "unassign"}
                      </p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {dataItem[0].assign_count > 0
                          ? dataItem[0].assign_count
                            ? dataItem[0].assign_count
                            : "_"
                          : dataItem[0].unassign_count
                          ? dataItem[0].unassign_count
                          : "_"}
                      </p>
                    </div>
                  </div>
                  <div className="my-1 col-lg-3 col-md-3 col-12">
                    <div className="d-flex flex-column">
                      <p className="confirm_label m-0 p-0">Status</p>
                      <p className="confirm_value my-1 m-0 p-0">
                        {" "}
                        {dataItem[0].assign_count > 0
                          ? dataItem[0].assign_count_status === 0
                            ? "Pending"
                            : `Assigned (${dataItem[0].assign_count} Students)`
                          : dataItem[0].unassign_count_status === 0
                          ? "Pending"
                          : `Unassigned (${dataItem[0].unassign_count} Students)`}
                      </p>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          )}
        {/* unassigned student popup */}
        <div>
          <>
            <Modal show={show} onHide={handleClose} size="lg" centered>
              <Modal.Header closeButton>
                <Modal.Title>
                  <h5 className="ModalHeader mb-0">Unassign Students</h5>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="ModalBodyHeight">
                <div class="mb-4 col-md-7">
                  <label for="StudentName" class="form-label confirm_value ">
                    Enter the number of students you want to unassign
                  </label>
                  <input
                    onChange={(e) => handlechangeCount(e)}
                    placeholder="Enter the Number"
                    type="number"
                    name="unassign_count"
                    value={
                      CountData.unassign_count <= 0
                        ? ""
                        : CountData.unassign_count
                    }
                    class={`${styles.border_head_color} form-control form-control-sm shadow-none input-font-size`}
                    id="overallMark"
                  />
                  {error.unassign_count && (
                    <small className={"error_message"}>
                      {error.unassign_count}
                    </small>
                  )}
                </div>
              </Modal.Body>
              <Modal.Footer>
                <div className="col-md-6 col-12 ListBtn">
                  <ul class="List-Button">
                    <li class="ListBtnItems">
                      <Link
                        onClick={handleClose}
                        to={handleClose}
                        className="secondaryButton "
                      >
                        Back to Students List
                      </Link>
                    </li>
                    <li class="ListBtnItems">
                      <Link
                        onClick={() => handleSendRequest(0)}
                        to={"javascript:void(0)"}
                        className="primaryButton "
                      >
                        Send Request
                      </Link>
                    </li>
                  </ul>
                </div>
              </Modal.Footer>
            </Modal>
          </>
        </div>
        {/* Assigned student popup */}
        <div className="model_header">
          <Modal show={open} onHide={handleModelClose} size="lg" centered>
            <Modal.Header closeButton>
              <Modal.Title>
                <h5 className="ModalHeader mb-0">Assign More Students</h5>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="ModalBodyHeight">
              <div class="mb-4 col-md-7">
                <label for="StudentName" class="form-label confirm_value ">
                  Enter the number of students you want to assign more
                </label>
                <input
                  value={
                    CountData.assign_count <= 0 ? "" : CountData.assign_count
                  }
                  type="number"
                  name="assign_count"
                  onChange={(e) => handlechangeCount(e)}
                  placeholder="Enter the Number"
                  class={`${styles.border_head_color} form-control form-control-sm shadow-none input-font-size`}
                  id="overallMark"
                />
                {error.assign_count && (
                  <small className={"error_message"}>
                    {error.assign_count}
                  </small>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="col-md-6 col-12 ListBtn">
                <ul class="List-Button">
                  <li class="ListBtnItems">
                    <Link
                      onClick={handleModelClose}
                      to={handleModelClose}
                      className="secondaryButton"
                    >
                      Back to Students List
                    </Link>
                  </li>
                  <li class="ListBtnItems">
                    <Link
                      onClick={() => handleSendRequest(1)}
                      to={"javascript:void(0)"}
                      className="primaryButton"
                      variant="primary"
                    >
                      Send Request
                    </Link>
                  </li>
                </ul>
              </div>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}
export default StudentsList;
